import * as React from "react";
import type { SVGProps } from "react";

interface IconPollProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const IconPoll = ({ cancelled = false, ...props }: IconPollProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 100 100"
    {...props}
  >
    <g>
    <image
      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAC4jAAAuIwF4pT92AAAB40lEQVR4nO3dO3LEMBAD0bkW7rZ3hzPH/kjqoaoD5CQeKYksl3fajumaDvABmArSxQsBH4CpIF28EPABmArSxQsBH4Dp70AmnzvTizPb8+8dcghET4HZCHI3RjejbAN5CqNbUQQJj7AV5Ond0Y27RJDwCILEHeIjK+6Q+g7xpT6+Q+JXlp+98SvLc0g9GI7nEE/q40k9/Onck3r+fFK//S7NHZIVtwiCzM93yKO3zu6QrMD4RhEkq0AqSAQ55R1Sd4gg9ZEVd8iqR8QIIsj4lfVxhxz0yOqm+FIPjyBI+OIFCV+2IOELFiR8qYKEL1KQ8OUJEr4wQRaUNILwxYwgfBmzIF6dhEcQJHzxgoQvW5DwBQsSvtSNIPjE5tBcDYJPaA7PlSD4ZOYFuQoEn8i8JILkfSD4JOZFESQ8giDhixckfNmChC9YkPClChK+SEHClydI+MIEWVDSCMIXM4LwZcyCeHUSHkGQ8MULEr5sQcIXLEj4UgUJX6Qg4csTJHxhgiwoaQThixlB+DJmQbw6CY8gSPjiBQlftiDhCxYkfKk0iH/fG0H60lz6v9/pyfTw3PLrCPSkemhu//0QeoI9JNf/5JHpox1YeHctOnwApoJ08ULAB2AqSBcvBHwApoJ08UL4AtIJH2Cw6A8kAAAAAElFTkSuQmCC"
      width={100}
      height={100}
    />
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default IconPoll;
